export const NAME = 'webhooks';
export const WEBHOOKS_FORM_NAME = 'webhooksForm';
